import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import registerServiceWorker from './registerServiceWorker';

import './assets/css/styles.css';

/*
* Adding basename="/dev" for sub-dir setup
*/
ReactDOM.render((
	<BrowserRouter>
		<App />
	</BrowserRouter>
	), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js